import { createTypedValidator } from '@takeshape/json-schema';
export const schema = {
    type: 'object',
    properties: {
        messageId: {
            type: 'string',
            description: 'Message ID for the message'
        }
    },
    required: ['messageId'],
    additionalProperties: false
};
export const validate = createTypedValidator(schema);
